'use strict';

wbApp.factory('stateCodesSvc', ['$resource', 'repositorySvc',
    function ($resource, repositorySvc) {

        var StateCode = $resource('/Api/PreviewStateCodes/Get', {}, {
            'query': { method: 'GET', isArray: true },
            'save': { method: 'POST', url: '/Api/PreviewStateCodes/Save' },
            'delete': { method: 'POST', url: '/Api/PreviewStateCodes/Delete' }
        });

        var stateCodes;

        function getAllAsync() {
            if (!stateCodes) {
                stateCodes = repositorySvc.get(StateCode, {});
            }
            return stateCodes;
        }

        function get(id) {
            if (stateCodes) {
                for (var i = 0; i < stateCodes.length; i++) {
                    var sc = stateCodes[i];
                    if (sc.id === id) {
                        return sc;
                    }
                }
            }
            return null;
        }

        function save(data, successCallback, errorCallback) {
            repositorySvc.save(
                StateCode,        // $resource
                stateCodes,       // collection
                data,             // entity
                successCallback,
                errorCallback);
        }

        function remove(data, errorCallback) {
            repositorySvc.remove(
                StateCode,        // $resource
                stateCodes,       // collection
                data,             // entity
                null,             // successCallback
                errorCallback);
        }

        return {
            getAllAsync: getAllAsync,
            save: save,
            remove: remove,
            get: get,
        }

    }]);